import React from "react";
import { TutorProvider } from "../context/TutorContext";
import TutorChatBubble from "./TutorChatBubble";

interface TutorWrapperProps {
  children: React.ReactNode;
}

/**
 * Wrapper component that provides the TutorProvider context
 * and renders the TutorChatBubble across the application
 */
const TutorWrapper: React.FC<TutorWrapperProps> = ({ children }) => {
  return (
    <TutorProvider>
      {children}
      <TutorChatBubble />
    </TutorProvider>
  );
};

export default TutorWrapper;
